import React from "react";
import { NavLink } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { useFetch, useFilter, useLanguage, usePagination } from "hooks";
import {
  GridList,
  Layout,
  SearchForm,
  SideFilter,
  MultimediaCard,
  TabSlider,
  Skeletons,
} from "components";

/*
this page show the Multimedia information resource with Links Types filters and search
 */

export default function List() {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const Tabs = [
    {
      type: 4,
      title: language.audioVisual,
    },
  ];
  const [currentTab, setCurrentTab] = React.useState(1);
  const tab = React.useRef(Tabs[currentTab - 1].type);
  const searchKey = React.useRef("");
  const [filterResponse, filterRequest] = useFetch(`getBooksFilters`, "POST");
  const filters = useFilter(filterResponse.result.data);
  const { page, handleSetPage } = usePagination();
  const [booksResponse, booksRequest] = useFetch(`getBooks`, "POST");

  const handleSetTab = (val) => {
    filters.reset();
    handleSetPage(1);
    setCurrentTab(val);
    tab.current = Tabs[val - 1].type;
  };

  const handleSearch = (keyword) => {
    searchKey.current = keyword;
    filters.reset();
    handleSetPage(1);
  };

  const handleGetData = React.useCallback(
    async (keyword) => {
      let filtersToSend = {};
      filters.selectedFilters.forEach((sf1) => {
        filtersToSend[sf1.key] = filters.selectedFilters
          .filter((sf2) => sf1.key === sf2.key)
          .map((sf2) => sf2.values)[0];
      });
      booksRequest(
        {
          filters: { ...filtersToSend },
          search_key: searchKey.current || keyword,
          section_type: tab.current,
        },
        `?page=${page}`
      );
    },
    [booksRequest, filters.selectedFilters, page, searchKey]
  );

  React.useEffect(() => {
    handleGetData();
  }, [filters.selectedFilters, handleGetData, page, currentTab]);

  React.useEffect(() => {
    filterRequest({ page_type: "books", parent_ids: [], section_ids: [4] });
  }, [filterRequest]);

  return (
    <Layout>
      <div id="multimedia_page" className="page_container pt-5">
        <section className="mb-3 page_top">
          <Container>
            <Row>
              <Col xs={12} className="mb-4">
                <h1 className="fw-medium text-primary text-center">
                  {language.multimedia}
                </h1>
              </Col>
              <Col xs={12} className="mb-4">
                <TabSlider
                  tabs={Tabs}
                  currentTab={currentTab}
                  setCurrentTab={handleSetTab}
                  alternate
                />
              </Col>
              <Col xs={12}>
                <Row className="align-items-center">
                  <Col xl={2} lg={2} md={0}></Col>
                  <Col xl={8} lg={8} md={12}>
                    <Row className="align-items-center">
                      <Col xl={9} lg={9} xs={9}>
                        <SearchForm
                          onSubmit={(keyword) => handleSearch(keyword)}
                        />
                      </Col>

                      <Col
                        xl={3}
                        lg={3}
                        md={3}
                        sm={3}
                        xs={3}
                        className="px-1 px-sm-2"
                      >
                        <NavLink
                          to="/search/advanced"
                          className="btn btn-primary btn-outline-primary-hover w-100 px-1 px-sm-3"
                        >
                          {language.advanceSearch}
                        </NavLink>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={2} lg={2} md={0}></Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="mb-3">
          <Container>
            <Row>
              <Col lg={3} xs={12}>
                {!filterResponse.loading && filterResponse.result.data && (
                  <SideFilter
                    title={language.multimediaFilter}
                    filters={filters}
                    subItemTitleSelector="type"
                    type="checkbox"
                  />
                )}
              </Col>
              <Col lg={9} xs={12} className="mx-auto">
                {!booksResponse.loading && booksResponse.result.data ? (
                  <GridList
                    perRow={3}
                    itemsCount={booksResponse.result.meta.total}
                    perPage={booksResponse.result.meta.per_page}
                    as={MultimediaCard}
                    items={booksResponse.result.data}
                  />
                ) : (
                  <Skeletons.CardsSkeleton count={12} perRow={3} />
                )}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  );
}
